import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from '@mui/icons-material/Done';
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface ProductTypeProps {
  open: boolean;
  handleClose: () => void;
}

function CreateProductTypeModal({
  open,
  handleClose,
}: ProductTypeProps) {


  const token = useSelector(setUserToken)
  const oauthTokenHeader = token?.payload?.user?.userToken;
  
  const [productTypeName, setproductTypeName] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const CreateNewProductType = async() => {
    const data = {
      type_name: productTypeName,
    };
    try{
      setIsLoading(true);
      setLoading(true);
      if (oauthTokenHeader) {
        await MetaEntitiesEndPointLogic.createMetaProductType(oauthTokenHeader, data);
      }else{
        throw new Error("User doesn't have permissions to create new themes");
      }
      if(oauthTokenHeader){
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaProductType(oauthTokenHeader,dispatch);
      }
      } catch (error) {
      console.error(error, "error");
    } finally{
      setLoading(false);
      setIsLoading(false);
      handleClose();
      setproductTypeName(null);
      await MetaEntitiesEndPointLogic.getMetaProductType(oauthTokenHeader,dispatch);
    }
  }


  const handleCancel = () => {
    handleClose();
    setproductTypeName(null);
  }

  return (
    <>
    {loading ? (<SimpleBackdrop />) : (
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
          Create New Product Type
          </DialogTitle>
          <Typography sx={{mb:1}}>Details</Typography>
          <Grid container mt={0} columnSpacing={3}>
            <Grid item xs={12}>
              <TextField
                value={productTypeName}
                onChange={(e:any) => setproductTypeName(e.target.value)}
                id="outlined-multiline-flexible"
                label="Product Type *" // Set your label here
                placeholder="Enter unique Product Type Name" // Set your placeholder here
                color="secondary"
                size="small"
                fullWidth
              />
            </Grid>
          </Grid>
          <Typography
            sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
          >
          This is a mandatory field.
          </Typography>

          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button color="secondary" onClick={handleCancel} sx={{mr:1}}>
              Cancel
            </Button>
            <Button variant="contained" color="secondary" disabled={!productTypeName} 
            data-tracker="237"
            onClick={CreateNewProductType}>
            Create <DoneIcon sx={{ml:1}} />
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    )}
    </>
  );
}

export default CreateProductTypeModal;
